import React, { useEffect } from 'react';
import { FaPassport, FaGlobeAmericas, FaBuilding } from 'react-icons/fa';
import PracticeAreaLayout from './PracticeAreaLayout';

const ImmigrationPage: React.FC = () => {
  useEffect(() => {
    document.title = 'Immigration Law | Janssen Law Professional Corporation';
  }, []);

  return (
    <PracticeAreaLayout
      title="Immigration Law"
      subtitle="Strategic immigration counsel with an international business perspective."
      heroImage="https://janssen-law.s3.us-east-2.amazonaws.com/immigration-law.png"
      slug="immigration"
      overview={
        <>
          <p>
            Janssen Law's immigration practice goes beyond standard immigration
            services. We approach immigration matters with a business-oriented mindset,
            understanding that relocation to Canada often involves complex corporate,
            real estate, and estate planning considerations.
          </p>
          <p>
            Charlotte Janssen's expertise in pre-immigration and estate/business
            planning, combined with Linh's dedicated immigration practice, provides
            clients with comprehensive counsel that addresses the full scope of their
            needs when moving to or expanding within Canada.
          </p>
          <p>
            We work with individuals, families, and businesses to navigate Canada's
            immigration system efficiently and strategically, whether for temporary
            work permits, permanent residence, or business immigration programs.
          </p>
        </>
      }
      services={[
        'Business Immigration Programs',
        'Pre-Immigration Planning',
        'Temporary Work Permits',
        'Permanent Residence Applications',
        'Family Sponsorship',
        'Citizenship Applications',
        'Immigration Compliance',
        'International Relocation Support',
        'Investor & Entrepreneur Programs',
        'Intra-Company Transfers',
        'Labour Market Impact Assessments',
        'Immigration Appeals',
      ]}
      whyUsTitle="Why Choose Janssen Law for Immigration?"
      whyUsDescription="We combine immigration expertise with international business law for a holistic approach to your move to Canada."
      whyUsFeatures={[
        {
          icon: <FaPassport />,
          title: 'Business-Oriented',
          description:
            'Our immigration practice integrates with corporate, tax, and estate planning for a comprehensive transition strategy.',
        },
        {
          icon: <FaGlobeAmericas />,
          title: 'International Perspective',
          description:
            'Charlotte\'s experience across three continents provides firsthand understanding of cross-border complexities.',
        },
        {
          icon: <FaBuilding />,
          title: 'Full-Service Support',
          description:
            'From immigration applications to real estate purchases and business setup, we handle all legal aspects of your move.',
        },
      ]}
    />
  );
};

export default ImmigrationPage;
